import { useSelector } from 'react-redux';
import VirtualizedThreadListMemberList from './VirtualizedThreadListMemberList';
import { useAutoSelectThreadListMember } from '../hooks/useAutoSelectThreadListMember';
import { useNavigateToThread } from '../../thread-search-and-filtering/hooks/useNavigateToThread';
import { getThreadListMembersWithOverlays } from '../../thread-list-member/selectors/getThreadListMembersWithOverlays';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { getViewOrderedBy } from 'find-and-filter-data/views-schema/public';
import { useInboxViewMembers, useMarkViewMemberSeen } from 'find-and-filter-data/view-members-data/public';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import PortalIdParser from 'PortalIdParser';
import { getUserId } from '../../selectors/userSelectors/getUserId';
import { getThreadListMemberFilters } from '../../thread-list-member/selectors/getThreadListMemberFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadListMembersSidebar = ({
  focusedThreadId
}) => {
  const agentId = useSelector(getUserId);
  const inboxId = useSelector(getCurrentInboxId);
  const portalId = PortalIdParser.get();
  const {
    sortDirection,
    threadStatus,
    viewId
  } = useSelector(getThreadListMemberFilters);
  const {
    fetchMore,
    hasMore,
    isInitialPageReceived,
    loading: isLoadingThreadListMembers,
    viewMembers
  } = useInboxViewMembers({
    inboxId,
    skip: true,
    sortDirection,
    threadStatus: threadStatus || undefined,
    viewId: viewId || undefined
  });
  const {
    navigateToThread
  } = useNavigateToThread();
  const focusedThreadListMember = viewMembers && focusedThreadId ? viewMembers.get(focusedThreadId) : undefined;
  const hasMoreThreadListMembers = hasMore;
  const view = useCurrentView();
  useMarkViewMemberSeen({
    agentId,
    portalId: portalId,
    inboxId,
    viewMember: focusedThreadListMember
  });
  const threadListMembersWithOverlays = useSelector(state => getThreadListMembersWithOverlays(state, {
    isInitialPageReceived,
    viewMembers,
    viewOrderBy: getViewOrderedBy(view)
  }));
  useAutoSelectThreadListMember({
    focusedThreadId,
    isLoadingThreadListMembers,
    navigateToThread,
    threadListMembers: threadListMembersWithOverlays
  });
  const handleFetchThreadListMembersPage = () => {
    if (hasMoreThreadListMembers && !isLoadingThreadListMembers) {
      fetchMore();
    }
  };
  return /*#__PURE__*/_jsx(VirtualizedThreadListMemberList, {
    fetchThreadListMembersPage: handleFetchThreadListMembersPage,
    isInitialPageReceived: isInitialPageReceived,
    focusedThreadListMember: focusedThreadListMember,
    hasMoreThreadListMembers: hasMoreThreadListMembers,
    isLoadingThreadListMembers: isLoadingThreadListMembers,
    onSelectThread: navigateToThread,
    threadListMembers: threadListMembersWithOverlays
  });
};
ThreadListMembersSidebar.displayName = 'ThreadListMembersSidebar';
export default ThreadListMembersSidebar;